import { useAuth as useCoreAuth } from '../contexts/AuthContext';
import { useUser } from '../contexts/UserContext';
import { SBTokenService } from '../services/SBTokenService';
import { useEffect } from 'react';

export const useAuth = () => {
  const auth = useCoreAuth();
  const user = useUser();

  useEffect(() => {
    if (auth.isAuthenticated && !auth.isLoading) {
      user.fetchUserData();
      user.fetchMeData();
    }
  }, [auth.isAuthenticated, auth.isLoading]);

  const login = async () => {
    await auth.login();
  };

  const logout = async () => {
    await auth.logout();
    await SBTokenService.clearToken();
  };

  return {
    ...auth,
    ...user,
    login,
    logout,
  };
};
